(() => {
  // filterService.js
  const filterService = {
    // 應用所有篩選條件
    applyFilters(data, filters, isLoading = false) {
      if (!data || data.length === 0) return [];

      // 創建一個深拷貝避免修改原始數據
      const filteredData = JSON.parse(JSON.stringify(data));

      // 篩選每個主要行程
      return isLoading
        ? filteredData
        : filteredData
          .map((mainGroup) => {
            // 如果選擇了特色標籤，且主行程不符合，也直接回傳 null
            if (
              filters.featureTags.size > 0 &&
              !this.matchesFeatureTag(mainGroup, filters.featureTags)
            ) {
              return null;
            }

            // 篩選該主要行程下的所有子行程
            mainGroup.groups = mainGroup.groups.filter(
              (group) =>
                this.matchesPriceRange(group, filters.priceRange) &&
                this.matchesDateRange(group, filters.dateRange) &&
                this.matchesGroupStatus(group, filters.groupStatus) &&
                this.matchesWeekday(group, filters.selectedWeekdays) &&
                this.matchesDayRange(group, filters.dayRanges) &&
                this.matchesAirline(group, filters.selectedAirlines)
            );

            // 如果沒有符合條件的子行程，也回傳 null
            if (mainGroup.groups.length === 0) {
              return null;
            }

            return mainGroup;
          })
          .filter(Boolean); // 過濾掉null值
    },

    // 檢查是否符合價格範圍
    matchesPriceRange(group, priceRange) {
      return (
        group.sitePrice >= priceRange[0] && group.sitePrice <= priceRange[1]
      );
    },

    // 檢查是否符合日期範圍
    matchesDateRange(group, dateRange) {
      const departureDate = new Date(group.leaveDate);
      const startDate = new Date(dateRange[0]);
      const endDate = new Date(dateRange[1]);

      // 將時間設為00:00:00以便純日期比較
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      return departureDate >= startDate && departureDate <= endDate;
    },

    // 檢查是否符合出團狀態
    matchesGroupStatus(group, statusFilters) {
      // 如果沒有選擇任何狀態，視為不進行篩選
      if (!statusFilters.guaranteed && !statusFilters.forming) {
        return true;
      }

      if (statusFilters.guaranteed && group.hotType === "6") {
        return true;
      }

      if (statusFilters.forming && group.hotType === "2") {
        return true;
      }

      return false;
    },

    // 檢查是否符合出發星期
    matchesWeekday(group, selectedWeekdays) {
      // 如果沒有選擇任何星期，視為不進行篩選
      if (selectedWeekdays.size === 0) {
        return true;
      }

      const departureDate = new Date(group.leaveDate);
      const weekday = departureDate.getDay(); // 0-6，分別代表週日到週六

      return selectedWeekdays.has(weekday);
    },

    // 檢查是否符合旅遊天數範圍
    matchesDayRange(group, dayRanges) {
      // 檢查是否有任何啟用的天數範圍
      const hasActiveRange = dayRanges.some((range) => range.active);

      // 如果沒有啟用的範圍，視為不進行篩選
      if (!hasActiveRange) {
        return true;
      }

      // 檢查是否符合任一啟用範圍
      return dayRanges.some((range) => {
        if (!range.active) return false;

        const days = group.groupDay;

        if (range.rangeStart === 0) {
          // X 天以下
          return days <= range.rangeEnd;
        } else if (range.rangeEnd === 0) {
          // X 天以上
          return days >= range.rangeStart;
        } else {
          // 區間
          return days >= range.rangeStart && days <= range.rangeEnd;
        }
      });
    },

    // 檢查是否符合特色標籤
    matchesFeatureTag(mainGroup, featureTags) {
      // 如果沒有選擇任何標籤，視為不進行篩選
      if (featureTags.size === 0) {
        return true;
      }

      // 如果沒有tag屬性，直接返回false
      if (!mainGroup.hashTagList.length) {
        return false;
      }

      // 將標籤分割為陣列
      const groupTags = mainGroup.hashTagList.map((tag) => tag.trim());

      // 檢查是否至少有一個標籤匹配
      for (const tag of groupTags) {
        if (featureTags.has(tag)) {
          return true;
        }
      }

      return false;
    },

    // 檢查是否符合航空公司
    matchesAirline(group, selectedAirlines) {
      // 如果沒有選擇任何航空公司，視為不進行篩選
      if (selectedAirlines.size === 0) {
        return true;
      }
      // 如果 group.airline 是陣列，檢查是否有任何一個航空公司在 selectedAirlines 中
      if (Array.isArray(group.airlineCodes)) {
        // 檢查陣列中的任何一個航空公司是否存在於 selectedAirlines
        return group.airlineCodes.some((airline) =>
          selectedAirlines.has(airline)
        );
      }

      // 如果 group.airline 不是陣列（是單一值），則直接檢查
      return selectedAirlines.has(group.airlineCodes);
    },
  };

  // 將服務掛載到全局
  window.filterService = filterService;
})();
